<!------------------------------------->
<!-- List tab detail layout.
 * File Name ..: master-regions.component.html
 * Generated by: ianday
 * Date .......: 12/12/23
--------------------------------------->
<div class="requesttypes-form-container">
    <div class="query-strip-container mat-elevation-z2">
        <table height="100%">
            <TR>
                <TD class="table-title-cell">
                    <i class="fa fa-cog table-icon-header"
                       style="width: 2em"></i>{{ formTitle }}
                </TD>

                <TD align="left" style="min-width: 400px;">
                    <input text id="txtFilter" #txtFilter
                           matTooltip="Type to match data in all columns except date fields"
                           class="qs_filter-field" [disabled]="this.isEditing"
                           (keyup)="applyFilter($event.target.value)" placeholder="<Filter>">
                    <button mat-button matSuffix mat-icon-button
                            matTooltip="Clear the filter" aria-label="Clear"
                            (click)="txtFilter.value=''; clearFilter();">
                        <mat-icon>close</mat-icon>
                    </button>
                </TD>
                <TD class="qs-label-cell" style="width: 60px; text-align: center;">Status:</TD>
                <TD style="width: 150px">
                    <mat-select
                            disableOptionCentering
                            [(value)]="selectedStatusFilter" floatLabel="never"
                            class="dw-mat-select"
                            style="font-size: 10pt;width: 120px;"
                            panelClass="local-drop-down-panel"
                            (selectionChange)="txtFilter.value=''; onChangeStatusFilterValue()">
                        <mat-option value='All'>All</mat-option>
                        <mat-option value='Active'>Active</mat-option>
                        <mat-option value='InActive'>InActive</mat-option>
                    </mat-select>
                </TD>
                <TD class="table-pagination-cell" align="right">{{ pagination }} Record(s) ...</TD>
            </TR>
        </table>
    </div>


        <div class="main-client-area">
            <!--------------------------->
            <!-- RECORDS TABLE         -->
            <!--------------------------->
            <div  [ngClass]="contentClassName" class="table-container mat-elevation-z1"
                 (keydown)="tableKeyDown($event)" tabindex="-1">
                <table mat-table [dataSource]="dataSource" matSort
                       (matSortChange)="onSortChange($event)">

                    <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on
                  the row definition" -->

                    <!-- ID -->
                    <ng-container matColumnDef="id">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef
                            style="background-color: white; z-index:99999; width: 100px;">Id
                        </th>
                        <td mat-cell style="width:100px !important;"
                            *matCellDef="let element;let tableRowIdx = index;">
                            {{ element.id }}
                        </td>
                    </ng-container>
                    <!-- Description -->
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            style="background-color: white; z-index:99999; width: 50%">Description
                        </th>
                        <td mat-cell style="width:50% !important;"
                            *matCellDef="let element">{{ element.description }}
                        </td>
                    </ng-container>

                    <!-- Active Status -->
                    <ng-container matColumnDef="activeStatus">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            style="background-color: white; z-index:99999">Status
                        </th>
                        <td mat-cell *matCellDef="let element" >

                            <dw-dropdown *ngIf="selectedRecord?.id == element.id"
                                         [disabled]="isEditing || !visibleModify"
                                         [useStatusOptions]="'status'"
                                         [selectedItem]="element.activeStatus"
                                         [controlWidth]="'120px'"
                                         (itemSelected)="element.activeStatus = $event; onStatusChange()">
                            </dw-dropdown>

                            <span *ngIf="selectedRecord?.id !== element.id"
                                  style="padding-left: 3px;">{{element.activeStatus}}</span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row
                        *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                        [ngClass]="{'row-selected': tableRowIdx == Idx}"
                        (click)="onRowClicked(row)">
                    </tr>
                </table>
                <app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
            </div>
            <!-------------------------------------->
            <!-- Control Strip                    -->
            <!-------------------------------------->
            <div class="mat-elevation-z2 control-strip">
                <button *ngIf="visibleAdd" mat-button [disabled]="this.isEditing"
                        matTooltipPosition="above"
                        class="command-button" matTooltip="Add a new record"
                        (click)="addModifyRecord(true)" >
                    <mat-icon>add_circle_outline</mat-icon>
                    Add New
                </button>
                <button *ngIf="visibleModify" class="command-button"
                        matTooltipPosition="above"
                        style="margin-top: 5px;" [disabled]="(Idx < 0|| this.isEditing)"
                        matTooltip="Edit a selected record" (click)="addModifyRecord(false)"
                        mat-button>
                    <mat-icon>edit</mat-icon>
                    Edit
                </button>
                <button *ngIf="visibleDelete" class="command-button"
                        matTooltipPosition="above"
                        style="margin-top: 5px;" [disabled]="(Idx < 0 || this.isEditing)"
                        matTooltip="Remove a selected record" (click)="removeRecord()"
                        mat-button>
                    <mat-icon>remove_circle_outline</mat-icon>
                    Remove
                </button>
            </div>
            <!------------------------------->
            <!--  Detail panel             -->
            <!------------------------------->
            <div id="requesttypes-details-panel" class="requesttypes-detail-container mat-elevation-z2"
                 style="margin-bottom: 2px;">
                <mat-tab-group animationDuration="0ms" (selectedTabChange)="doTabChange()"
                               [(selectedIndex)]=selectedTabIndex>
                    <mat-tab label="Details" [disabled]="isEditing">
                        <div class="sub-tab-container-class detail-tab-additional">
                            <div class="dwform" style="padding-right: 15px;">

                                <div class="dwform-cell-nopadding" style="min-width: 500px;">

                                    <div class="dwform-row-double-gap"></div>
                                    <div class="dwform-row">
                                        <label class="label-field">ID:</label> <span
                                            class="form-required"> </span>
                                        <input class="input-field-short" style="width:80px" disabled="true"
                                               [(ngModel)]="id"
                                               type="text">
                                    </div>

                                    <div class="dwform-row-gap"></div>

                                    <div class="dwform-row">
                                        <label class="label-field">Description:</label>
                                        <span class="form-required">*</span>
                                        <input class="input-field" id="description"
                                        [disabled]="!isEditing"
                                               [(ngModel)]="description"
                                               style="text-transform: capitalize; width:380px"
                                               placeholder="<Description>"
                                               type="text">

                                        <div class="dwform-row-gap"></div>

                                        <div class="dwform-row">
                                            <label class="label-field">Status:</label> <span
                                                class="form-required">*</span>
                                            <dw-dropdown
                                                    id="activeStatusId"
                                                    [disabled]="!isEditing"
                                                    [selectedItem]="activeStatus"
                                                    (itemSelected)="activeStatus = $event"
                                                    [controlWidth]="'120px'" [useStatusOptions]="'status'">
                                            </dw-dropdown>

                                        </div>
                                    </div>
                                </div>
                                <!----------------------->
                                <!-- ERROR LINE --------->
                                <!----------------------->
                                <div class="error-line" [hidden]='!strErr.length'
                                     style="text-align:left">{{ strErr }}
                                </div>
                                <!----------------------->
                                <!-- SAVE STRIP        -->
                                <!----------------------->
                                <div class="save-close-strip" style="bottom: 3px;">

                                    <button  class="command-button" *ngIf="this.isEditing"
                                            (click)="submitRecord()" matTooltip="Submit the selected record"
                                            mat-button>
                                        <mat-icon>check_circle_outline</mat-icon>
                                        Submit
                                    </button>
                                    <button class="command-button" *ngIf="this.isEditing"
                                            (click)="cancelSubmitRecord()" matTooltip="Cancel edit" mat-button>
                                        <mat-icon>highlight_off</mat-icon>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="History" [disabled]="isEditing">
                        <div class="sub-tab-container-class detail-tab-additional">
                            <transaction-history #history></transaction-history>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
</div>
